export default "__VITE_PUBLIC_ASSET__a2cd3542__"